<template>
    <div class="oxq-box">
        <p class="oxq-title"><strong>[O/X Quiz]</strong> {{ data.content }}</p>
        <div>
            <span class="btn-ox" :class=' { "selected": selectO, "answer":(isAnswerChecked&&data.ans==true) } ' @click='selO'>O</span>
            <span class="btn-ox" :class=' { "selected": selectX, "answer":(isAnswerChecked&&data.ans==false) } ' @click='selX'>X</span>
        </div>
        <p class="oxq-hint" v-show=' isHintShow '>힌트 : {{ data.hint }}</p>
        <p class="oxq-action-box">
            <span class="btn-hint" v-show=' data.hint && !isHintShow && !isAnswerChecked ' @click=' isHintShow = !isHintShow ' >힌트</span>
            <span class="btn-ans" v-show=' !isAnswerChecked ' @click=' checkAnswer '>정답확인</span>
        </p>
        <transition>
            <div class="oxq-check-mark" v-if=' isAnswerChecked '>{{ (selectO?data.ans:!data.ans)?"O":"X" }}</div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
        }
    },
    data(){
        return {
            isSelect: false,
            selectO: false,
            selectX: false, // 
            isHintShow: false, // 힌트 메세지 보기 여부
            isAnswerChecked: false // 정답 확인 여부
        }
    },
    methods: {
        selO(){ this.selectX = false; this.selectO = true; this.isSelect=true; },
        selX(){ this.selectX = true; this.selectO = false; this.isSelect=true; },
        checkAnswer(){
            if ( !this.isSelect ) {
                alert("답을 골라주세요!");
                return false;
            }
            // 정답 확인
            try {
                var audio = new Audio(`/sound/${ (this.selectO?this.data.ans:!this.data.ans)?"o":"x" }.mp3`);
                audio.play();
            } catch(e) { console.log(e); }
            this.isAnswerChecked = !this.isAnswerChecked;
        }
    },
    updated(){
        if( this.isAnswerChecked ){
            this.$destroy();
        }
    }
}
</script>

<style>
.oxq-box {
    position: relative;
    border: 1px dotted #ccc;
    padding: 0 20px;
}
.oxq-box .oxq-check-mark{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    text-align: center;
    font-size: 160px;
    font-weight: bold;
    color: red;
}
.oxq-box .oxq-title {
    font-size: 1.25em;
}
.oxq-box .oxq-hint {
    color: #006666;
}
.oxq-box .btn-ox {
    display: inline-block;
    box-sizing: border-box;
    background: #eee;
    border-radius: 5px;
    width: 49%;
    margin-left: 1%;
    padding: 16px 0;
    text-align: center;
    font-size: 2em;
    font-weight: bold;
    cursor: pointer;
}
.oxq-box .btn-ox.selected {
    background: #2c3e50;
    color: #eee;
}
.oxq-box .btn-ox.answer {
    border: 10px solid #42b983;
}

.oxq-action-box{
    text-align: right;
}
.oxq-box .btn-hint, .oxq-box .btn-ans {
    display: inline-block;
    box-sizing: border-box;
    border-radius: 48px;
    padding: 12px 80px;
    cursor: pointer;
}
.oxq-box .btn-hint {
    background: #eee;
    margin-right: 16px;
}
.oxq-box .btn-ans {
    background: #eee;
}
</style>
